import { render } from "./CreateGang.vue?vue&type=template&id=ad87ac50"
import script from "./CreateGang.vue?vue&type=script&lang=js"
export * from "./CreateGang.vue?vue&type=script&lang=js"

import "./CreateGang.vue?vue&type=style&index=0&id=ad87ac50&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__